module.exports = {"511124100":"研城镇","511124101":"马踏镇","511124102":"竹园镇","511124103":"研经镇","511124104":"周坡镇","511124105":"千佛镇","511124106":"王村镇","511124107":"三江镇","511124108":"东林镇","511124109":"磨池镇","511124200":"集益乡","511124201":"纯复乡","511124202":"三教乡","511124203":"高滩乡","511124204":"宝五乡","511124205":"四合乡","511124206":"黄钵乡","511124207":"胜泉乡","511124208":"门坎乡","511124209":"石牛乡","511124210":"高凤乡","511124211":"金峰乡","511124212":"分全乡","511124213":"镇阳乡","511124214":"天云乡","511124215":"乌抛乡","511124216":"大佛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511124.json
// module id = 2151
// module chunks = 0